<template>
  <v-dialog
    v-bind="$attrs"
    v-model="dialog"
    :overlay="false"
    transition="dialog-transition"
    max-width="640"
    overlay-opacity="0.8"
  >
    <v-card max-width="640" class="pa-0">
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>Filtro</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="fechar">
          <v-icon>close</v-icon>
        </v-btn>
      </v-app-bar>

      <div class="pa-3 pt-1 pb-2" style="display: flex; flex-direction: column">
        <div
          style="font-size: 18px; width: 100%; display: block; padding-top: 4px"
        >
          Categorias
        </div>
        <div class="caption">Selecione uma ou mais categorias</div>
        <v-chip-group v-model="categorias" column multiple class="spaceEvenly">
          <v-chip
            outlined
            active-class="accent"
            v-for="categoria in $store.state.categorias"
            :key="categoria.id"
            >{{ categoria.nome }}</v-chip
          >
        </v-chip-group>

        <v-divider class="my-2" />

        <div style="display: flex; width: 100%; max-height: 28px">
          <div style="font-size: 18px; display: block; float: left">
            Faixa de valores
          </div>

          <v-switch
            v-model="filtrarValores"
            style="float: right; margin: 3px -8px 0px auto"
          />
        </div>
        <div class="caption" style="float: left">
          Selecione uma faixa de valores
        </div>

        <div
          :style="
            !filtrarValores
              ? 'display: flex; width: 100%; pointer-events: none; opacity: 0.4'
              : 'display: flex; width: 100%'
          "
        >
          <v-slider
            class="ml-0"
            style="border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 16px; padding: 0px 8px; margin: 4px 4px 0px 0px"
            track-color="grey"
            always-dirty
            min="0"
            max="500"
            hide-details
            v-model="valorInicial"
          />
          <v-slider
            class="mr-0"
            style="border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 16px; padding: 0px 8px; margin: 4px 0px 0px 4px"
            track-color="grey"
            always-dirty
            min="0"
            max="500"
            hide-details
            v-model="valorFinal"
          />
        </div>
        <div
          :style="
            !filtrarValores
              ? 'display: flex; align-items: center; pointer-events: none; opacity: 0.4'
              : 'display: flex; align-items: center'
          "
        >
          <span class="caption" style="width: 50%; display: block"
            >Valor Inicial</span
          >
          <span
            class="h6 mr-1"
            style="width: 100%; display: block; text-align: right"
            >R$ {{ valorInicial | valorBR }}</span
          >
          <span class="caption ml-1" style="width: 50%; display: block"
            >Valor Final</span
          >
          <span
            class="h6"
            style="width: 100%; display: block; text-align: right"
            >R$ {{ valorFinal | valorBR }}</span
          >
        </div>

        <v-divider class="my-2" />

        <div v-if="$auth.user.tipo !== 'fornecedor'">
          <div style="display: flex; width: 100%; max-height: 28px">
            <div style="font-size: 18px; display: block">
              Fornecedor
            </div>
          </div>
          <div class="caption">Selecione um fornecedor</div>
          <v-select
            v-model="fornecedor"
            placeholder="Todos"
            ref="fornecedor"
            :items="fornecedores"
            item-text="nome_fantasia"
            item-value="id"
            dense
            outlined
            clearable
            return-object
            hide-details
            rounded
            class="mb-2 mt-1 paddindSelect"
          />
        </div>

        <v-divider class="my-2" />

        <v-btn
          depressed
          class="ml-auto my-1 primary"
          style="float: right"
          @click="aplicarFiltro"
          >Aplicar filtro</v-btn
        >
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    parametros: {
      type: Object,
    },
  },
  name: "filtro",

  data() {
    return {
      dialog: false,
      categorias: [],
      filtrarValores: false,
      valorInicial: 0,
      valorFinal: 0,
      fornecedores: [],
      fornecedor: {},
    };
  },

  methods: {
    abrir(value) {
      this.dialog = true;
      this.categorias = [...this.parametros.categorias];
      this.filtrarValores = this.parametros.filtrarValores;
      this.valorInicial = this.parametros.valorInicial;
      this.valorFinal = this.parametros.valorFinal;
      this.fornecedores = this.parametros.fornecedores;
    },

    fechar() {
      this.dialog = false;
    },

    aplicarFiltro(key) {
      this.$emit("onAplicarFiltro", {
        categorias: this.categorias,
        filtrarValores: this.filtrarValores,
        valorInicial: this.valorInicial,
        valorFinal: this.valorFinal,
        fornecedor: this.fornecedor,
      });
      this.dialog = false;
    },
  },
};
</script>

<style></style>
